<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <!-- <vx-card> -->
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="operatorZone"
            :description="false"
            @selected="handleSelected2"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.OperatorZone") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Operator Zone' })"
                  size="small"
                  >{{ $t("setup.label.CreateOperatorZone") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.SourceOperatorCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.DestinationOperatorCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.ImpactCategory") }}</vs-th>
              <vs-th>{{ $t("setup.label.Rank") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="operatorZone"
                v-for="(operatorZone, index) in data"
              >
                <vs-td :data="operatorZone.sourceOperatorCode">{{
                  operatorZone.sourceOperatorCode
                }}</vs-td>
                <vs-td :data="operatorZone.destinationOperatorCode">{{
                  operatorZone.destinationOperatorCode
                }}</vs-td>
                <vs-td :data="operatorZone.impactCategory">{{
                  operatorZone.impactCategory
                }}</vs-td>
                <vs-td :data="operatorZone.rank">{{ operatorZone.rank }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected2(operatorZone)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                      @click.stop="editOperZone(operatorZone.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        editJobsRumPopup = true;
                        delId = operatorZone.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="editJobsRumPopup"
      :title="$t('setup.label.FeeMaster')"
      @deletePressed="deleteOperatorZone(delId)"
      @cancelPressed="editJobsRumPopup = false"
    >
    </delete-popup>
    <!-- </vx-card> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      deleteIcPopup: false,
      deleteNumberZonePopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      apnZone: (state) => state.zoneSetup.GetApnZone,
      operatorZone: (state) => state.zoneSetup.GetOperatorZone,
      icZone: (state) => state.zoneSetup.GetIcZone,
      numberZone: (state) => state.zoneSetup.GetNumberZone,
      products: (state) => state.zoneSetup.GetUsageRatePlan,
    }),
  },
  methods: {
    async getOperatorZoneData() {
      this.loading = true;
      try {
        this.$store.dispatch("zoneSetup/setOperatorZoneList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteOperatorZone(id) {
      this.editJobsRumPopup = false;
      try {
        await this.$store.dispatch("zoneSetup/deleteOperatorZone", id);
        await this.getOperatorZoneData();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Operator Zone Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        this.$toasted.error("Something Went Wrong", {
          duration: 2000,
        });
      }
    },

    editOperZone(id) {
      this.$router.push({ name: "Edit Operator Zone", params: { id: id } });
    },
    handleSelected2(operatorZone) {
      this.$router.push({
        name: "View Operator Zone",
        params: { id: operatorZone.id },
      });
    },
  },
  mounted() {
    this.getOperatorZoneData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
